import React from "react";
import Layout from "components/Layout";
import "styles/legal.css";

const ImpressumPage = () => {
  return (
    <Layout>
      <section className="legal-page">
        <div className="legal-shell">
          <h1>Impressum</h1>

          <p className="legal-meta">
            Angaben gemäß § 5 TMG sowie § 18 Abs. 2 MStV.
          </p>

          <h2>Diensteanbieter</h2>
          <p>
            MediConsult Group
            <br />
            Cremon 11
            <br />
            20457 Hamburg
          </p>

          <h2>Kontakt</h2>
          <p>
            Web:{" "}
            <a
              href="https://mediconsult.group"
              target="_blank"
              rel="noopener noreferrer"
            >
              mediconsult.group
            </a>
          </p>

          <h2>Vertretungsberechtigte Personen</h2>
          <p>Geschäftsführung: wird in der finalen Fassung ergänzt.</p>

          <h2>Schlichtungsverfahren</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
            vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
            übermittelte oder gespeicherte fremde Informationen zu überwachen.
          </p>

          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
            Inhalte auch keine Gewähr übernehmen.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default ImpressumPage;
